export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hey, I'm Hamzah</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">Full Stack</span>{" "}
            <br />
            Developer
          </h1>
          <p className="hero--section-description">
          Baltimore-based self-taught programmer with over two years of web and mobile development experience.
            <br /> I am also a certified data analyst who loves exhilarating challenges and unlocking insights from raw information.
          </p>
        </div>
        <button className="btn btn-primary">Get In Touch</button>
      </div>
      <div className="hero--section--img">
        <img src="./img/Iceland png/me.png" alt="Hero Section" />
      </div>
    </section>
  );
}
